import { Injectable } from '@angular/core';
import Api from '../../helpers/api';
import { Observable } from 'rxjs';

const BASE = 'whatsapp';

export interface WhatsAppInstancia {
  id: number;
  uazapi_instance_id: string;
  nome: string;
  status: 'disconnected' | 'connecting' | 'connected';
  qrcode: string | null;
  paircode: string | null;
  profile_name: string | null;
  profile_pic_url: string | null;
  last_disconnect: string | null;
  last_disconnect_reason: string | null;
  created_at: string;
  updated_at: string;
}

export interface InstanciaStatusResponse {
  instance: WhatsAppInstancia;
  status: { connected: boolean; loggedIn: boolean; jid: string | null };
  qrcode: string | null;
  paircode: string | null;
}

export interface MensagemEnviada {
  id: number;
  id_instancia: number | null;
  nome_instancia: string | null;
  destinatario: string;
  data_hora: string;
  tipo_mensagem: string;
  texto: string | null;
  link_arquivo: string | null;
  message_id_uazapi: string | null;
  status: 'pendente' | 'enviada' | 'entregue' | 'falha';
  erro_envio: string | null;
  created_at: string;
}

export interface MensagensListResponse {
  data: MensagemEnviada[];
  total: number;
  offset: number;
  limit: number;
}

export interface MensagensFilterParams {
  id_instancia?: number;
  destinatario?: string;
  data_inicio?: string;
  data_fim?: string;
  status?: 'pendente' | 'enviada' | 'entregue' | 'falha';
  offset?: number;
  limit?: number;
}

@Injectable({ providedIn: 'root' })
export class WhatsAppService {
  private apiCall = this.api.new().silent();

  constructor(private api: Api) {}

  listarInstancias(): Observable<WhatsAppInstancia[]> {
    return this.apiCall.get(`${BASE}/instancias`);
  }

  buscarInstancia(id: number): Observable<WhatsAppInstancia> {
    return this.apiCall.get(`${BASE}/instancias/${id}`);
  }

  criarInstancia(body: { name: string; systemName?: string; adminField01?: string; adminField02?: string; fingerprintProfile?: string; browser?: string }): Observable<WhatsAppInstancia> {
    return this.apiCall.post(`${BASE}/instancias`, body);
  }

  editarInstancia(id: number, body: { name: string }): Observable<WhatsAppInstancia> {
    return this.apiCall.put(`${BASE}/instancias/${id}`, body);
  }

  statusInstancia(id: number): Observable<InstanciaStatusResponse> {
    return this.apiCall.get(`${BASE}/instancias/${id}/status`);
  }

  conectarInstancia(id: number, body?: { phone?: string }): Observable<any> {
    return this.apiCall.post(`${BASE}/instancias/${id}/connect`, body || {});
  }

  deletarInstancia(id: number): Observable<{ deleted: boolean }> {
    return this.apiCall.delete(`${BASE}/instancias/${id}`);
  }

  enviarTexto(idInstancia: number, body: { number: string; text: string; [k: string]: any }): Observable<any> {
    return this.apiCall.post(`${BASE}/instancias/${idInstancia}/mensagens/texto`, body);
  }

  enviarMidia(idInstancia: number, body: { number: string; file: string; type?: string; text?: string; docName?: string; [k: string]: any }): Observable<any> {
    return this.apiCall.post(`${BASE}/instancias/${idInstancia}/mensagens/midia`, body);
  }

  listarMensagens(params?: MensagensFilterParams): Observable<MensagensListResponse> {
    const query: { [k: string]: string | number } = {};
    if (params) {
      if (params.id_instancia != null) query['id_instancia'] = params.id_instancia;
      if (params.destinatario) query['destinatario'] = params.destinatario;
      if (params.data_inicio) query['data_inicio'] = params.data_inicio;
      if (params.data_fim) query['data_fim'] = params.data_fim;
      if (params.status) query['status'] = params.status;
      if (params.offset != null) query['offset'] = params.offset;
      if (params.limit != null) query['limit'] = params.limit;
    }
    return this.apiCall.get(`${BASE}/mensagens`, query);
  }

  excluirMensagem(id: number): Observable<{ deleted: boolean; id: number }> {
    return this.apiCall.delete(`${BASE}/mensagens/${id}`);
  }
}
